export default {
  clearFilters({ dispatch }) {
    dispatch("updateFilters", [])
  }
}
